import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('INTERVENTIONS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class InterventionsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'interventions' como el nombre del recurso a la clase base
    super('interventions');
    log.debug('Servicio de Intervenciones inicializado');
  }

  /**
   * Firma del vale: con el archivo firmado (key de S3) las piezas del folio
   * pasan a Consumido (con su bitácora CONSUMO) y el folio a Firmado.
   */
  public async sign(payload: { intervention: string; file: { key: string; fileName?: string } }) {
    return this.request<any>('interventions/sign', 'POST', payload);
  }

}
